import { api } from "./api";

const KEY = "pc_offline_queue";
const FORCE = "pc_force_offline";

export const getQueue = () => JSON.parse(localStorage.getItem(KEY) || "[]");
const setQueue = (q) => {
  localStorage.setItem(KEY, JSON.stringify(q));
  window.dispatchEvent(new Event("pc-queue"));
};

export const isForcedOffline = () => localStorage.getItem(FORCE) === "1";
export const setForcedOffline = (v) => {
  localStorage.setItem(FORCE, v ? "1" : "0");
  window.dispatchEvent(new Event("pc-queue"));
};
export const isOffline = () => isForcedOffline() || !navigator.onLine;

export function enqueue(kind, payload) {
  const client_ref = `OFF-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).slice(2, 6).toUpperCase()}`;
  const item = { client_ref, kind, payload: { ...payload, offline_at: new Date().toISOString() }, queued_at: new Date().toISOString() };
  setQueue([...getQueue(), item]);
  return item;
}

export async function flush() {
  const q = getQueue();
  if (!q.length || isOffline()) return null;
  const { data } = await api.post("/sync", { items: q.map(({ client_ref, kind, payload }) => ({ client_ref, kind, payload })) });
  const done = new Set(data.results.filter((r) => r.status !== "failed").map((r) => r.client_ref));
  setQueue(getQueue().filter((i) => !done.has(i.client_ref)));
  return data.results;
}
